import { Text, Box, Button as ThemeUIButton } from "theme-ui";

import { SvgOrImg } from "components";
import * as styles from "./SharpeningCustomOptions.styles";

export default function SharpeningCustomOptions({
  descriptionText = {},
  options,
  value,
  onChange,
}) {
  return (
    <>
      <Box sx={styles.optionsContainer}>
        {options.map((option) => {
          const isSelected = value === option.value;
          return (
            <ThemeUIButton
              key={option.value}
              type="button"
              variant="unstyled"
              sx={styles.option({ isSelected })}
              onClick={() => {
                onChange(option.value);
              }}
            >
              <Box
                sx={styles.sharpnessBox({
                  isSelected,
                })}
              >
                <SvgOrImg type={option?.image?.type} src={option?.image?.url} />
              </Box>
              <Text variant="copy1">{option.label}</Text>
            </ThemeUIButton>
          );
        })}
      </Box>

      <Box sx={styles.sharpnessGuideSliderContainer}>
        <Box sx={styles.sharpnessGuideTextContainer}>
          <Text as="div" variant="copy2">
            {descriptionText.textLeft.heading}
          </Text>
          <Text as="div" variant="copy3" sx={styles.sharpnessGuideTextLeftSub}>
            {descriptionText.textLeft.subHeading}
          </Text>
        </Box>
        <Box sx={styles.sharpnessGuideTextContainer}>
          <Text as="div" variant="copy2">
            {descriptionText.textRight.heading}
          </Text>
          <Text as="div" variant="copy3" sx={styles.sharpnessGuideTextRightSub}>
            {descriptionText.textRight.subHeading}
          </Text>
        </Box>
      </Box>
    </>
  );
}
